import { render, staticRenderFns } from "./ModalAddEditOrder.vue?vue&type=template&id=c50610f4&"
import script from "./ModalAddEditOrder.vue?vue&type=script&lang=js&"
export * from "./ModalAddEditOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddEditOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports